import { useQuery } from '@tanstack/react-query'
import type { ReactNode } from 'react'

import { getSetupState } from './api'
import { SetupContext } from './context'

export function SetupProvider({ children }: { children: ReactNode }) {
  /* entitlements ride this, so it has to move with the billing overview: both
   * go stale while the user is away paying or waiting on an approval, and
   * neither is reachable by a broadcast a backgrounded tab never received. */
  const { data } = useQuery({
    queryKey: ['setup'],
    queryFn: ({ signal }) => getSetupState(signal),
    refetchOnWindowFocus: true
  })

  return (
    <SetupContext.Provider value={{ setupState: data ?? null }}>
      {children}
    </SetupContext.Provider>
  )
}
